import { useContext } from "react";
import { useFetch } from "use-http";

import TrimmaContext from "../contexts/TrimmaContext";

export default function useTrimmaContext(...args) {
  const { apiPath } = useContext(TrimmaContext);
  if (typeof args[0] === "string") {
    args[0] = `${apiPath}${args[0]}`;
  } else {
    args.unshift(apiPath);
  }
  return useFetch(...args);
}
